import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import { LocalDate } from "@js-joda/core";
import type { EnumDayOfWeek } from "@/app/services/generated/enums/enumDayOfWeek.generated";
import { defineComponent } from "vue";

export function despatchDateHighlighter(
  date: LocalDate,
  despatchDays: EnumDayOfWeek[],
  leadTimeDays: number,
  primaryEventColour: string = "brand02",
  warningEventColour: string = "warningMedium"
) {
  let dayOfWeekKey = date.dayOfWeek().value();
  const today = tenantService.today;
  // Check if values are in the future or today and the day of the week matches distribution Object
  if (
    !date.isBefore(today) &&
    despatchDays.some(
      (distributionActiveDay: EnumDayOfWeek) =>
        dayOfWeekKey === distributionActiveDay.key
    )
  ) {
    // If the value is within the lead time, Show but highlight with warning color
    if (leadTimeDays && date.isBefore(today.plusDays(leadTimeDays))) {
      return warningEventColour;
    }
    return primaryEventColour;
  }
  return "";
}

export function despatchDateStringHighlighter(
  date: string,
  despatchDays: EnumDayOfWeek[],
  leadTimeDays: number,
  primaryEventColour: string = "brand02",
  warningEventColour: string = "warningMedium"
) {
  return date
    ? despatchDateHighlighter(
        LocalDate.parse(date),
        despatchDays,
        leadTimeDays,
        primaryEventColour,
        warningEventColour
      ) || false
    : false;
}

export const BmDateHighlighter = defineComponent({
  methods: {
    getEventFromDaysAndLeadTime(
      date: string,
      despatchDays: EnumDayOfWeek[],
      leadTimeDays: number
    ): boolean | string {
      return despatchDateStringHighlighter(date, despatchDays, leadTimeDays);
    },
  },
});
